module.exports = __webpack_public_path__ + "static/img/03.807c8462.png";